import getRuntimeEnv from './env';

/** Check wether the current user is an opus Admin and thus has edit rights. */
const userCanEdit = (profile: any): any => {
  const adminGroup =
    getRuntimeEnv().REACT_APP_OKTA_OPUS_ADMIN_GROUP || 'Okta_Opus_Admin'; // TODO: remove 'Okta_Opus_Admin' in the next release
  return Boolean(profile.groups && profile.groups.includes(adminGroup));
};

export default userCanEdit;
